import { render, staticRenderFns } from "./OrdemDoDia.vue?vue&type=template&id=5bcbaef6&scoped=true"
import script from "./OrdemDoDia.vue?vue&type=script&lang=js"
export * from "./OrdemDoDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbaef6",
  null
  
)

export default component.exports